import React from "react";

interface Props {
    rating: number;
    count: number;
    translations: {[key: string]: string};
}

const ConsultantRating: React.FC<Props> = ({translations, rating, count}) => {
    if (count === 0) {
        return <></>
    }

    const star = <svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 20 20">
        <g xmlns="http://www.w3.org/2000/svg" id="star">
        <path fill="#feb600" d="M10 1.3l2.388 6.722H18.8l-5.232 3.948 1.871 6.928L10 14.744l-5.438 4.154 1.87-6.928-5.233-3.948h6.412L10 1.3z"/>
    </g>
    </svg>;

    return <div className={`rating`} style={{marginLeft:'10px'}}>
        <ul>{Array.from(Array(rating)).map((_, i) => <li key={i}>{star}</li>)}</ul> <span>({count}&nbsp;
        { translations["profile.reviews.title"] })</span>
    </div>
}

export default ConsultantRating;